

























import {Component, Prop, Vue} from "vue-property-decorator";
import UploadIcon from "@share/web-conferences/components/media-library/media-upload/UploadIcon.vue";
import {validateSize} from "@share/web-conferences/helpers/media/FileSizeValidator";
import {UploadSlidesService} from "@share/web-conferences/data/media-library/UploadSlidesService";
import MediaUploadProgress from "@share/web-conferences/components/media-library/media-upload/MediaUploadProgress.vue";
import {Notice} from "@service/components/toast/type/Notice";
import {NoticeLevel} from "@service/components/toast/type/Enums";

@Component({
    name: "MediaUpload",
    components: {MediaUploadProgress, UploadIcon}
})
export default class MediaUpload extends Vue {
    @Prop() uploadFileService: UploadSlidesService;

    fileInputName = 'fileInput';
    isHoveringFile = false;
    maxFileSize = parseInt(process.env.VUE_APP_FILE_MAX_SIZE || '16'); //im mb
    currentFile: File | null = null;

    get classes() {
        return {
            'is-hovering': this.isHoveringFile
        }
    }

    onClick() {
        if (this.$refs[this.fileInputName]) {
            (this.$refs[this.fileInputName] as HTMLInputElement).click();
        }
    }

    onDragOver() {
        this.isHoveringFile = true;
    }

    onDragLeave() {
        this.isHoveringFile = false;
    }

    onDrop(event: DragEvent) {
        const files = event?.dataTransfer?.files ?? [];

        if (files && files.length) {
            this.uploadFile(files[0]);
        }

        this.isHoveringFile = false;
    }

    onChange() {
        const fileInput: HTMLInputElement = this.$refs[this.fileInputName] as HTMLInputElement;
        if (fileInput && fileInput.files) {
            this.uploadFile(fileInput.files[0]);
        }
    }

    async uploadFile(file: File) {
        this.currentFile = file;

        if (file.type != "application/pdf") {
            this.showError(this.$t('web-conferences.media-library.upload.errors.pdf').toString());
            return;
        }

        if (validateSize(file, this.maxFileSize)) {
            //starts upload
            const uploadResult = await this.uploadFileService.uploadPresentationFile(file);
            (this.$refs[this.fileInputName] as HTMLInputElement).value = '';

            if (uploadResult.type == 'success') {
                this.showSuccess();
                this.$emit('uploaded', uploadResult.slides);
            }
            else {
                this.showError(uploadResult.message);
            }
        }
        else {
            this.showError(this.$t('web-conferences.media-library.upload.errors.size').toString());
        }
    }

    showError(message: string) {
        this.$store.dispatch('notice/submitNotice', {
            text: message,
            level: NoticeLevel.danger
        } as Notice)
    }

    showSuccess() {
        this.$store.dispatch('notice/submitNotice', {
            text: this.$t('web-conferences.media-library.upload.success'),
            level: NoticeLevel.success
        } as Notice);
    }
}
